var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.$route.meta.title,"border":"","fixed":"","placeholder":"","z-index":"1000"}})}
var staticRenderFns = []

export { render, staticRenderFns }